import { useContext } from 'react';
import Stepper, { useStepper } from '../../Stepper';
import { StoreContext } from '../../Store';
import { postEPOExport } from '../../apiCalls';

const StepWrapper = ({
  stepTitle,
  stepText,
  stepKey,
  handleNextClick,
  handleBackClick,
  hideUnlessVisited = false,
  hideUntilActive = false,
  isFirst = false,
  isLast = false,
  children,
  clickCount = 0,
  disableNext = false,
}) => {
  const { localData, setDataByKey, unvisitStep } = useStepper();

  const store = useContext(StoreContext);

  const setToDropdown = async (e) => {
    if (store.lockDirection[0] === true) {
      localData.openMovementRedirectModal({
        title: 'Movement Type Change',
        body: (
          <>
            <p className="bold">Warning - changes will be lost</p>
            <p>Are you sure you want to change your movement type? Doing so will lose your current changes.</p>
          </>
        ),
      });
    } else {
      setDataByKey('movementType', e);
      store.exOrImport[1]('EPO - ' + e);
      const fd = new FormData();
      fd.append('to', 'false');
      fd.append('movementType', e);
      setDataByKey('exportId', '');
      setDataByKey('importId', '');
      setDataByKey('hasTransitMrn', '');
      setDataByKey('transitMrn', '');
      setDataByKey('mrnDocuments', []);
      setDataByKey('euPref', '');
      setDataByKey('pref', '');
      unvisitStep('2. Exit Port');
      const updateDropdown = await postEPOExport('routeChoice', fd);
      if (updateDropdown && e === 'Import') {
        setDataByKey('exportCountry', 'eu');
        setDataByKey('importCountry', 'gb');
        store.fromFlagOptions[1](updateDropdown);
        const fd2 = new FormData();
        fd2.append('to', 'true');
        fd2.append('movementType', 'Import');

        const updateImportDropdown = await postEPOExport('routeChoice', fd2);
        if (updateImportDropdown) {
          store.toFlagOptions[1](updateImportDropdown);
          updateImportDropdown.forEach((f) => {
            if (f.abbreviation === 'gb') {
              setDataByKey('importCountry', 'gb');
              setDataByKey('importId', f.id);
              setDataByKey('toAreaCode', f.areaCode);
            }
          });
        }
      } else if (updateDropdown && e === 'Export') {
        unvisitStep('eu_origin');
        unvisitStep('Preferential Origin');
        store.fromFlagOptions[1](updateDropdown);
        updateDropdown.forEach(async (e) => {
          if (e.abbreviation === 'gb') {
            setDataByKey('exportCountry', 'gb');
            setDataByKey('fromAreaCode', e.areaCode);
            setDataByKey('importCountry', 'eu');
            setDataByKey('exportId', e.id);
            const fd1 = new FormData();
            fd1.append('from', e.id);
            fd1.append('to', 'true');
            fd1.append('movementType', 'Export');
            const updateImportDropdown = await postEPOExport('routeChoice', fd1);
            if (updateImportDropdown) {
              store.toFlagOptions[1](updateImportDropdown);
            }
          }
        });
      }
    }
  };

  return (
    <Stepper.Step
      hideUnlessVisited={hideUnlessVisited}
      hideUntilActive={hideUntilActive}
      text={stepText}
      stepKey={stepKey}
    >
      <h2 className="mb-3 themed-text">{stepTitle}</h2>
      <div className="themed-text">
        <label
          className="d-inline-flex align-items-center gap-2 mb-2"
          style={{ marginBottom: '10px', marginRight: '86px' }}
        >
          <input
            type="radio"
            data-testid="import-radio"
            checked={localData.movementType === 'Import'}
            onChange={() => setToDropdown('Import')}
            disabled={!isFirst}
          />
          <span>Import</span>
        </label>

        <label className="d-inline-flex align-items-center gap-2" style={{ marginBottom: '10px' }}>
          <input
            type="radio"
            data-testid="export-radio"
            checked={localData.movementType === 'Export'}
            onChange={() => setToDropdown('Export')}
            disabled={!isFirst}
          />
          <span>Export</span>
        </label>
      </div>
      <div
        className=" px-2 mt-1 pt-2 d-flex flex-column"
        style={{ borderRadius: '0.9rem', background: 'rgba(255, 255, 255)', minHeight: '485px' }}
      >
        {children}

        <section className="d-flex justify-content-between mt-auto pb-4 px-3">
          {isFirst ? (
            <div />
          ) : (
            <button type="button" className="stepper-button red" onClick={handleBackClick}>
              Back
            </button>
          )}
          <button
            type="button"
            className="stepper-button"
            onClick={handleNextClick}
            disabled={clickCount >= 1 || disableNext}
            data-testid={isLast ? 'submit-button' : undefined}
          >
            {isLast ? 'Submit' : 'Next'}
          </button>
        </section>
      </div>
    </Stepper.Step>
  );
};

export default StepWrapper;
